import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { Footer } from './Footer';
import '../scss/Home.css';
import '../scss/Residential.css';

export class Layout extends Component {

  render () {
    return (
      <div style={{height: "100%"}}>
        <NavMenu />
        <Container fluid style={{marginTop: "85px", paddingLeft: "0", paddingRight:"0", minHeight: "100%"}}>
          {this.props.children}
        </Container>
        <Footer/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout.jsx